import { MenuItem } from '@chakra-ui/react'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type React from 'react'
import type {
  CurrencyDto,
  NetworkDto,
  NetworkOffRampDto,
} from '../types/coreApi-types'
import Icon from './Icon'

interface Props {
  onClick: () => void
  title: string
  subtitle?: string
  isActive?: boolean
  imageName?: CurrencyDto | NetworkDto | NetworkOffRampDto | null
  icon?: JSX.Element
  disabled?: boolean
  customButton?: JSX.Element
}

const DropdownCell: React.FC<Props> = ({
  onClick,
  title,
  subtitle,
  isActive,
  imageName,
  icon,
  disabled,
  customButton,
}) => {
  const isDarkMode =
    document.body.getAttribute('theme') === 'dark' &&
    localStorage.getItem('color-theme') === 'dark'

  return (
    <MenuItem
      onClick={() => {
        if (!disabled) onClick()
      }}
      _focus={{ bg: 'transparent' }}
      _hover={{ bg: isDarkMode ? '#14191F' : '#F2F4F6' }}
      className={`flex w-full items-start justify-between p-0 dark:bg-brand-dark-card hover:bg-brand-light-card-border z-50 dark:hover:bg-brand-dark-background group rounded-lg transition-all cursor-pointer border-2 border-solid ${
        isActive
          ? 'border-2 border-brand-accent border-solid'
          : 'border-transparent'
      }`}
      style={
        disabled
          ? {
              cursor: 'not-allowed',
            }
          : {}
      }
      disabled={disabled}
    >
      <div
        className="flex items-start gap-3 mr-10 min-w-0 flex-1"
        style={
          disabled
            ? {
                filter: 'opacity(0.5) grayscale(1)',
              }
            : {}
        }
      >
        {imageName && <Icon src={imageName} size="md" />}
        {icon}

        <div className="min-h-[32px] flex flex-col justify-center py-1 min-w-0 max-w-[min(100%,20rem)]">
          <p className="text-brand-light-text-default dark:text-white font-semi text-[12px] leading-tight">
            {title}
          </p>
          {subtitle && (
            <p className="text-description-subtle text-[11px] leading-snug whitespace-normal mt-0.5">
              {subtitle}
            </p>
          )}
        </div>
      </div>
      {isActive && (
        <FontAwesomeIcon
          icon={faCheck}
          className="text-xs text-brand-accent mr-1.5 mt-1 shrink-0"
        />
      )}
      {customButton}
    </MenuItem>
  )
}

export default DropdownCell
